<template>
<div class="sm-employ">
  <div class="sm-employ__img">
    <img :src="item.image || require('@/assets/img/user.svg')">
  </div>
  <div class="sm-employ__names">
    {{item.firstSurname}} {{item.secondSurname}}, {{item.firstName}}
  </div>

  <div class="sm-employ__dot"
    :class="getStatusDay"
    v-if="item.report"></div>
  <!-- <EmpTareo v-if="showTareo" :employ="item"/> -->
</div>
</template>

<script>
// import EmpTareo from '@/components/empleado/EmpTareo'

export default {
  props: {
    item: Object
  },
  components: {
    // EmpTareo
  },
  data() {
    return {
      // showTareo: false
    }
  },
  computed: {
    getStatusDay(){
      let data = this.item.report

      if(data.status=='assistance')
        return 'sm-employ__dot--blue'
      if(data.status=='excused-absence')
        return 'sm-employ__dot--fuchsia'
      if(data.status=='absence')
        return 'sm-employ__dot--red'
      if(data.status=='vacation')
        return 'sm-employ__dot--green'
      if(data.status=='medical-break')
        return 'sm-employ__dot--yellow'
      if(data.status=='medical-break-subsidized')
        return 'sm-employ__dot--orange'
      if(
        data.diurnal||data.nocturnal)
        return 'sm-employ__dot--purple'
        

      // if(data.contractual > 0){
      // console.log('gaaa',data.contractual)
      //   if(
      //     data.diurnal1||data.diurnal2||
      //     data.nocturnal1||data.nocturnal2)
      //     return 'sm-employ__dot--purple'
      //   if(data.contractual) return 'sm-employ__dot--blue'
      // }
      // else{
      //   if(data.vacation)
      //     return 'sm-employ__dot--green'
      //   else if(data.medicalRest)
      //     return 'sm-employ__dot--yellow'
      //   else if(data.subsRest)
      //     return 'sm-employ__dot--orange'
      //   else
      //     return 'sm-employ__dot--red'
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}


.sm-employ{
  height: 4rem;
  width: 21rem;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin: .5rem 1rem;
  padding: 0 1rem;
  border-radius: 6px;
  // position: relative;
  @include mq($lg){
    cursor: pointer;
  }

  &__names{
    max-width: 14rem;
  }

  &__img{
    width: 2rem;
    height: 2rem;
    // margin-right: 1rem;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  // &__names{}

  &__dot{
    height: 1rem;
    width: 1rem;
    border-radius: 100%;
    // background-color: #000;
    &--red{background-color: #ef476f}
    &--blue{background-color: #2cc0d5}
    &--green{background-color: #93c737}
    &--yellow{background-color: #f9de5c}
    &--orange{background-color: #d8ff00}
    &--purple{background-color: #7b1fa2}
    &--fuchsia{background-color: #d939cd}
  }
}

</style>
